import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { withStyles } from '@material-ui/core';
//
import colors from 'theme/colors';

const { darkBorder } = colors;

const ExpansionPanelSummary = withStyles({
  root: {
    fontSize: 14,
    fontWeight: 600,
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: `1px solid ${darkBorder}`,
    marginBottom: -1,
    minHeight: 42,
    '&$expanded': {
      minHeight: 56,
    },
    padding: '0px 8px 0px 16px',
  },
  content: {
    margin: 0,
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

export default ExpansionPanelSummary;
